// 获取预估价
export const getPredictPriceText = predictSsuUnitPriceText => {
  return predictSsuUnitPriceText?.predictShowPrice
    ? `${predictSsuUnitPriceText?.predictTypeMsgPrefix}${predictSsuUnitPriceText?.priceSymbol}${predictSsuUnitPriceText?.predictShowPrice}${predictSsuUnitPriceText?.predictPriceUnitSuffix}`
    : ''
}

// 获取ssu价格
export const getSsuPriceInfo = ssuPrice => {
  const isShowWeightUnitPrice = ssuPrice?.isShowWeightUnitPrice
  const showWeightUnitPrice = Number(isShowWeightUnitPrice) === 1
  const weightUnitPrice = ssuPrice?.weightUnitPrice
  const weightPriceUnit = ssuPrice?.weightPriceUnit
  const unitPrice = ssuPrice?.unitPrice
  const priceUnit = ssuPrice?.priceUnit
  const unitPricePrefix = ssuPrice?.unitPricePrefix
  const preFormat = ssuPrice?.preFormat
  const salePricePrefix = showWeightUnitPrice ? '约¥' : '¥'
  const salePrice = showWeightUnitPrice ? weightUnitPrice : unitPrice
  const salePriceSuffix = showWeightUnitPrice
    ? '/' + weightPriceUnit
    : '/' + priceUnit

  return {
    priceSymbol: salePricePrefix,
    priceValue: salePrice,
    priceUnitText: salePriceSuffix,
    unitPricePrefix,
    preFormat
  }
}

// 获取sku价格
export const getSkuPriceInfo = skuPrice => {
  const isShowWeightUnitPrice = skuPrice?.isShowWeightUnitPrice
  const showWeightUnitPrice = Number(isShowWeightUnitPrice) === 1
  const weightPriceUnit = skuPrice?.weightPriceUnit
  const skuUnit = skuPrice?.skuUnit

  const salePricePrefix = showWeightUnitPrice ? '约¥' : '¥'
  const salePriceSuffix = showWeightUnitPrice
    ? '/' + weightPriceUnit
    : '/' + skuUnit
  let salePrice = ''
  const minPrice = skuPrice?.minPrice || ''

  if (showWeightUnitPrice) {
    salePrice = skuPrice.minWeightPrice
    if (skuPrice.minWeightPrice !== skuPrice.maxWeightPrice) {
      salePrice += '-' + skuPrice.maxWeightPrice
    }
  } else {
    salePrice = skuPrice.minPrice
    if (skuPrice.minPrice !== skuPrice.maxPrice) {
      salePrice += '-' + skuPrice.maxPrice
    }
  }
  return {
    priceSymbol: salePricePrefix,
    priceValue: salePrice,
    priceUnitText: salePriceSuffix,
    minPrice: minPrice
  }
}
// 获取商品包规总价
export const getTotalPriceWithFp = ssuPrice => {
  let totalPriceWithFp = ssuPrice?.totalPriceWithFp || ''
  if (totalPriceWithFp) {
    totalPriceWithFp = '¥' + ssuPrice?.totalPriceWithFp
  } else {
    totalPriceWithFp = ''
  }
  return totalPriceWithFp
}
